var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sp_header"},[(_vm.showClose)?_c('i',{staticClass:"el-icon-back",attrs:{"title":"Close"},on:{"click":_vm.handleClose}}):_vm._e(),_c('h2',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }